var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-max" }, [
    _c("table", { ref: "table", staticClass: "single__table" }, [
      _c(
        "tbody",
        { style: _vm.tableStyle },
        [
          _vm.$store.getters.currentItemVariation.filter.hasManufacturer &&
          _vm.$store.getters.currentItemVariation.item.manufacturer
            .externalName !== "" &&
          _vm.$store.getters.currentItemVariation.item.manufacturer
            .externalName !== "Weber Büro"
            ? _c("tr", [
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.singleItemManufacturer")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.$store.getters.currentItemVariation.item.manufacturer
                        .externalName
                    )
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasDimensions && !_vm.hasDimensionsProp
            ? _c("tr", [
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.singleItemDimensions")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$store.getters.currentItemVariation.variation
                          .lengthMM
                      )
                    )
                  ]),
                  _vm._v("  ×\n                    "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$store.getters.currentItemVariation.variation
                          .widthMM
                      )
                    )
                  ]),
                  _vm._v("  ×\n                    "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$store.getters.currentItemVariation.variation
                          .heightMM
                      )
                    )
                  ]),
                  _vm._v(" mm\n                ")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.$store.getters.currentItemVariation.variation.weightG !== "" &&
            _vm.$store.getters.currentItemVariation.variation.weightG != 0) ||
          (_vm.$store.getters.currentItemVariation.variation.weightNetG !==
            "" &&
            _vm.$store.getters.currentItemVariation.variation.weightNetG != 0)
            ? _c("tr", [
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.singleItemWeight"))
                  )
                ]),
                _vm._v(" "),
                _vm.$store.getters.currentItemVariation.variation.weightNetG !==
                  "" &&
                _vm.$store.getters.currentItemVariation.variation.weightNetG !=
                  0
                  ? _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            (
                              _vm.$store.getters.currentItemVariation.variation
                                .weightNetG / 1000
                            )
                              .toString()
                              .replace(".", ",")
                          ) +
                          " kg"
                      )
                    ])
                  : _c("td", [
                      _vm._v(
                        _vm._s(
                          (
                            _vm.$store.getters.currentItemVariation.variation
                              .weightG / 1000
                          )
                            .toString()
                            .replace(".", ",")
                        ) + " kg"
                      )
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sortedProperties, function(prop) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(prop.property.names.name))]),
              _vm._v(" "),
              _c("td", { domProps: { innerHTML: _vm._s(prop.texts.value) } })
            ])
          }),
          _vm._v(" "),
          _vm.hasManufacturerDataPart1 || _vm.hasManufacturerDataPart2
            ? _c("tr", [
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Weberbuero::Template.singleProductSafetyLabel"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        "data-target": "#eusafety",
                        "data-toggle": "modal",
                        href: "#"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.singleProductSafetyLink"
                            )
                          ) +
                          "\n                    "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "eusafety-wrapper" } }, [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "eusafety", tabindex: "-1", role: "dialog" }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("div", { staticClass: "modal-title h3" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Weberbuero::Template.singleProductSafetyModalTitle"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _vm.hasManufacturerDataPart1
                  ? _c("div", [
                      _c("strong", { staticClass: "h3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.singleProductSafetyManufacturererInfo"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm.manufacturerData.responsibleName
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsibleName)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsibleStreet ||
                        _vm.manufacturerData.responsibleHouseNo
                          ? _c("div", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.manufacturerData.responsibleStreet
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.manufacturerData.responsibleHouseNo
                                  )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsiblePostCode
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsiblePostCode)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsibleTown
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsibleTown) +
                                  "\n                                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsibleCountryObject
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.manufacturerData.responsibleCountryObject
                                    .names[0].name
                                )
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasManufacturerDataPart2
                  ? _c("div", [
                      _c("strong", { staticClass: "h3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Weberbuero::Template.singleProductSafetyContactInfo"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm.manufacturerData.responsibleEmail
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsibleEmail)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manufacturerData.responsiblePhoneNo
                          ? _c("div", [
                              _vm._v(
                                _vm._s(_vm.manufacturerData.responsiblePhoneNo)
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          "aria-label": "Close",
          "data-dismiss": "modal",
          type: "button"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }